var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-cloud-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.33317 21.6563C3.72519 20.58 2.6665 18.7469 2.6665 16.6667C2.6665 13.5419 5.05518 10.9751 8.10616 10.6925C8.73026 6.89618 12.0268 4 15.9998 4C19.9728 4 23.2694 6.89618 23.8935 10.6925C26.9445 10.9751 29.3332 13.5419 29.3332 16.6667C29.3332 18.7469 28.2745 20.58 26.6665 21.6563M10.6665 21.3333L15.9998 16M15.9998 16L21.3332 21.3333M15.9998 16V28",
    stroke: "currentColor",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.e9a024b63eff39df679b58eaaff7f46f.svg";
export { ForwardRef as ReactComponent };